import { shortSymbolFormatted } from "common/constants";

interface SelectMetalProps {
    selectedMetal: DefaultMetals;
    setSelectedMetal: (value: DefaultMetals) => void;
    listMetals: DefaultMetals[];
  }
  
  function SelectMetal({
    selectedMetal,
    setSelectedMetal,
    listMetals
  }: SelectMetalProps) {
    return (
      <div>
        <select
          value={selectedMetal}
          onChange={(e) => {
              setSelectedMetal(e.target.value as DefaultMetals);
          }}
          className='mr-2 lg:mr-2 p-1 text-[14px] rounded border bg-white dark:bg-gray-700 text-gray-900 dark:text-white h-[32px]'
        >
          {listMetals.map((metal) => (
            <option key={metal} value={metal}>
              {shortSymbolFormatted[metal]}
            </option>
          ))}
        </select>
      </div>
    );
  }
  
  export default SelectMetal;